import RelationshipModel from '../model/RelationshipModel'
import PickerControl from '../../../lib/ui/PickerControl'
import TextControl from '../../../lib/ui/TextControl'
import SelectPerson from '../../person/action/SelectPerson'

export default class RelationshipForm {
  constructor (element, args) {
    let fieldsetRelationship = document.createElement('fieldset')
    let legendRelationship = document.createElement('legend')
    legendRelationship.innerHTML = 'Relatie'
    fieldsetRelationship.appendChild(legendRelationship)

    this.id = args.relationship.values.id
    let popup = null

    this.person = new PickerControl(fieldsetRelationship, {label: 'Deze persoon', value: args.relationship.values.person_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectPerson(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.person.setValue(item.values.id, item)
            } else {
              this.person.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.person.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.target = new PickerControl(fieldsetRelationship, {label: 'De andere persoon', value: args.relationship.values.target_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectPerson(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.target.setValue(item.values.id, item)
            } else {
              this.target.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.person.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.description = new TextControl(fieldsetRelationship, {label: 'Omschrijving', value: args.relationship.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('relationships'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetRelationship)

    element.appendChild(fragment)
  }

  getValue () {
    let relationship = new RelationshipModel()
    relationship.person = this.person.getItem()
    relationship.target = this.target.getItem()
    relationship.values.id = this.id
    relationship.values.person_id = this.person.getValue()
    relationship.values.target_id = this.target.getValue()
    relationship.values.description = this.description.getValue()
    return relationship
  }

  setValue (relationship) {
    this.id = relationship.values.id
    this.person.setValue(relationship.values.person_id, relationship.person)
    this.target.setValue(relationship.values.target_id, relationship.target)
    this.description.setValue(relationship.values.description)
  }
}



// WEBPACK FOOTER //
// ./js/modules/relationship/ui/RelationshipForm.js